import { render, staticRenderFns } from "./BrandSelect.vue?vue&type=template&id=2ffd576b&"
import script from "./BrandSelect.vue?vue&type=script&lang=js&"
export * from "./BrandSelect.vue?vue&type=script&lang=js&"
import style0 from "./BrandSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports